module.exports = __webpack_public_path__ + "static/media/k1.fed1c495.png";